module.exports = __webpack_public_path__ + "img/ama_short@3x.469fc44f.png";